<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :title="$t('payment_links.new_link')" width="680px" class="choose-content diglog-card">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('payment_links.create_payment_link') }}
      </div>
      <div class="item-container" @click="onClickSingleDisbursementBtn">
        <el-card shadow="hover">
          <div class="item-title">
            {{ $t('payment_links.single_payment_link') }}
          </div>
          <p class="item-content">
            {{ $t('payment_links.tip_5') }}
          </p>
        </el-card>
      </div>
      <div class="item-container" @click="onClickBatchDisbursementBtn">
        <el-card shadow="hover">
          <div class="item-title">
            {{ $t('payment_links.batch_payment_link') }}
          </div>
          <p class="item-content">
            {{ $t('payment_links.tip_4') }}
          </p>
        </el-card>
      </div>
    </el-dialog>
    <BatchPaymentModal ref="batchPaymentModal" v-on="$listeners" />
    <SinglePaymentmentModal ref="singlePaymentModal" v-on="$listeners" />
  </div>
</template>

<script>
import BatchPaymentModal from './BatchPaymentModal.vue'
import SinglePaymentmentModal from './SinglePaymentModal.vue'
export default {
  name: 'Choose_Create_Payment_Way_Modal',
  components: {
    BatchPaymentModal,
    SinglePaymentmentModal
  },
  data() {
    return {
      dialogVisible: false // 控制弹框显示隐藏
    }
  },
  methods: {
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogVisible = value
    },
    onClickSingleDisbursementBtn() {
      this.changModalStatus(false)
      this.$refs.singlePaymentModal.changModalStatus(true)
    },
    onClickBatchDisbursementBtn() {
      this.changModalStatus(false)
      this.$refs.batchPaymentModal.changModalStatus(true)
    }

  }
}
</script>

<style scoped lang="scss">
.choose-content{
  border-radius: 14px;
}
.item-container{
  margin-bottom: 30px;
  cursor:pointer;
}
.item-title{
  font-size: 18px;
  font-weight: bold;
}
.item-content{
  font-size: 16px;
}

</style>
